module.exports = {
    twoWay: true,
    priority: 1000,
    bind: function () {
        var self = this;

        $(this.el)
            .select2({
                multiple: $(this.el).attr('multiple') == 'multiple',
            })
            .on('change', function () {
                self.set(getSelectValues(this));
            });
    },
    update: function (value) {
        $(this.el).val(value).trigger('change');
    },
    unbind: function () {
        $(this.el).off().select2('destroy');
    },
};

function getSelectValues(select) {
    var result = [];
    var options = select && select.options;
    var opt;

    for (var i = 0, iLen = options.length; i < iLen; i++) {
        opt = options[i];

        if (opt.selected) {
            result.push(parseInt(opt.value) || parseInt(opt.text));
        }
    }
    return result;
}



// WEBPACK FOOTER //
// ./resources/scripts/portal/components/feedback/directives/Select2.js